export function debugLog(message: string, ...args: unknown[]): void {
    const devEnvValues = ['local', 'development'];
    if (devEnvValues.includes(process.env.VUE_APP_ENV ?? '')) {
        console.log('[DEBUG - Localhost only]', message, ...args);
    }
}
